export default __webpack_public_path__ + "assets/images/pay_first.f5c3bd.png";